import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export default function LegalPage({ title, content }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-[#f7f8fc] font-[Lato,Arial,sans-serif] text-[#404040]">
      <Helmet>
        <title>{title} | Be With Law</title>
      </Helmet>
      <article className="mx-auto max-w-5xl px-4 py-10 sm:px-8 sm:py-16">
        <div className="rounded-2xl bg-white px-5 py-8 shadow-sm ring-1 ring-[#e4e6ee] sm:px-12 sm:py-12">
          <h1 className="mb-3 text-3xl font-bold text-[#0A1F8F] sm:text-5xl">{title} | Be With Law</h1>
          <p className="mb-10 text-sm text-gray-500">Effective Date: August 27, 2026 | Last Updated: August 27, 2026</p>
          <div className="whitespace-pre-line text-[16px] leading-8">{content}</div>
        </div>
      </article>
    </main>
  );
}
